export function capitalize (input)  {
    return input;
}